import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import WHATS_NEW_CONTENT from "../data/whatsNewContent";

function WhatsNewModal({ show, versions, onClose }) {
  const { t } = useTranslation();
  const modalRef = useRef(null);

  useEffect(() => {
    if (!show) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    setTimeout(() => modalRef.current?.focus(), 0);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", handleKey);
    };
  }, [show, onClose]);

  if (!show || !versions?.length) return null;

  return createPortal(
    <>
      <div
        className="modal fade show d-block"
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        style={{ zIndex: 2000 }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" ref={modalRef} tabIndex={-1}>
            <div className="modal-header">
              <h5 className="modal-title">{t("whats_new_title")}</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              />
            </div>
            <div className="modal-body">
              {versions.map((v, i) => {
                const content = WHATS_NEW_CONTENT[v];
                if (!content) return null;
                return (
                  <div key={v} className={i > 0 ? "mt-3" : undefined}>
                    <p className="fw-semibold mb-1">
                      {t(content.titleKey)}{" "}
                      <span className="text-muted fw-normal" style={{ fontSize: "0.85em" }}>v{v}</span>
                    </p>
                    <ul className="mb-0">
                      {content.items.map((key) => (
                        <li key={key}>{t(key)}</li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn ez-button-full"
                onClick={onClose}
              >
                {t("whats_new_close")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} />
    </>,
    document.body
  );
}

export default WhatsNewModal;
